<div style="text-align:center;padding-top:10px" *ngIf="myReportsFolders != undefined && myReportsFolders.length == 0"
  translate>
  Select 'Add Folders' to organize the reports you use most frequently
</div>

<div *ngIf="myReportsFolders != undefined && myReportsFolders.length > 0 ">
  <div class="flex-content">
    <mat-table style="width: 100%;" #table [dataSource]="tylerMatData" multiTemplateDataRows matSort matSortDisableClear
      matSortActive="FolderName" id="myReportsFoldersTable" aria-label="My Reports Folder" tabindex="0">

      <!-- More -->
      <ng-container matColumnDef="More">
        <mat-header-cell *matHeaderCellDef>
            <i [ngClass]="isExpandAll ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                (click)="expandAll()" aria-hidden="true"></i>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span aria-label="Expand row for more details">
                <i [ngClass]="checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                    aria-hidden="true"></i>
            </span>
        </mat-cell>
    </ng-container>

      <!-- FolderName -->
      <ng-container matColumnDef="FolderName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate>Folder</span>
          <filter [data]="tylerMatData" columnName="FolderName" dataType="string" id="folderFilter" class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let mrf">
          {{mrf.FolderName}}
        </mat-cell>
      </ng-container>

      <!-- FolderDescription -->
      <ng-container matColumnDef="FolderDescription">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate>Description</span>
          <filter [data]="tylerMatData" columnName="FolderDescription" dataType="string" id="folderFilter"
            class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let mrf">
          {{mrf.FolderDescription}}
        </mat-cell>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="Actions">
        <mat-header-cell *matHeaderCellDef class="print-ignore">Actions
        </mat-header-cell>
        <mat-cell *matCellDef="let mrf; let i = index;" class="print-ignore">
          <tyl-mat-menu id="actionMenu{{i}}" image="actions.png">
            <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="editFolder(mrf)">
              <span translate>Edit Folder</span>
            </button>
            <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="manageReports(mrf)">
              <span translate>Manage Reports in Folder</span>
            </button>
            <mat-divider>
            </mat-divider>
            <button id="delete{{i}}" mat-menu-item class="menuItem" (click)="deleteFolder(mrf)">
              Delete
            </button>
          </tyl-mat-menu>
        </mat-cell>
      </ng-container>

      <!-- expandedDetail -->
      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let mrf; let j = dataIndex" class="mat-detail-card">
          <!-- Report Areas Table -->
          <mat-table [dataSource]="mrf.ReportsInFolder" style="width: 50%;" multiTemplateDataRows class="subjectAreaTable">

            <!-- ReportName -->
            <ng-container matColumnDef="ReportName">
              <mat-header-cell *matHeaderCellDef>
                <span translate>Report</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let rpt">
                <a class="link" (click)="reportClick(rpt)">{{rpt.Description}}</a>
              </mat-cell>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="Actions">
              <mat-header-cell *matHeaderCellDef class="print-ignore">Actions
              </mat-header-cell>
              <mat-cell *matCellDef="let rpt; let i = index;" class="print-ignore">
                <tyl-mat-menu id="actionMenu{{i}}" image="actions.png">
                  <button id="folderforthisReportClick{{i}}" mat-menu-item class="menuItem" (click)="folderforthisReportClick(rpt, mrf)">
                    <span translate>Folders for this Report</span>
                  </button>
                  <!-- <button id="reportOptions{{i}}" mat-menu-item class="menuItem" (click)="reportOptionsClick(rpt)">
                    <span translate>Report Options</span>
                  </button> -->
                  <mat-divider>
                  </mat-divider>
                  <button id="delete{{i}}" mat-menu-item class="menuItem" (click)="deleteReportClick(rpt, mrf)">
                    Remove
                  </button>
                </tyl-mat-menu>
              </mat-cell>
            </ng-container>

            <!-- Row Definitions -->
            <mat-header-row *matHeaderRowDef="reportAreaColumns; sticky: true" id="reportsHeader">
            </mat-header-row>
            <mat-row *matRowDef="let rpt; columns: reportAreaColumns; let j = dataIndex" id="folder_report{{j}}"
              tabIndex="0" style="overflow: hidden;">
            </mat-row>
          </mat-table>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnDisplay; sticky: true" id="myReportsFoldersHeader">
      </mat-header-row>
      <!-- Data rows -->
      <mat-row *matRowDef="let row; columns: columnDisplay; let i = index;" id="myReportsFoldersDataRow{{i}}"
        tabindex="0" style="padding:0px;overflow:hidden;" matRipple (click)="toggleExpanded(row)"
        (keydown)="rowKeyPress($event, row)">
      </mat-row>
      <mat-row *matRowDef="let row; columns: ['expandedDetail']"
        [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden" class="mat-detail-row">
      </mat-row>
    </mat-table>
  </div>
</div>